import {
  URL,
  TWEET,
  HASHTAGS
} from '../constants/social';

const url = encodeURIComponent(URL);
const tweet = encodeURIComponent(TWEET);

const tags = (hashtags) => {
  hashtags.replace(/\s+/g, '');
  hashtags = hashtags.replace(/#/g, '');
  hashtags = encodeURIComponent(hashtags);
  hashtags = hashtags.replace(/%2C/g, ',');
  return hashtags;
};

export const FACEBOOK_URL = `https://www.facebook.com/sharer.php?u=${url}`;
export const TWITTER_URL = `https://twitter.com/intent/tweet?text=${tweet}`;



/** WEBPACK FOOTER **
 ** ./src/js/libs/get-social.js
 **/